import {
    ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS,
    ADMINGETMAPPINGBANKLISTCOMPARE_FAILED,
    RESET_ADMINGETMAPPINGBANKLISTCOMPARE,
    LOADING_ADMINGETMAPPINGBANKLISTCOMPARE,
    NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetMappingBankCompareList = () => {
    return { type: RESET_ADMINGETMAPPINGBANKLISTCOMPARE };
};

const AdminGetMappingBankCompareLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETMAPPINGBANKLISTCOMPARE });
    await adminServices
        .post("getMappingBankList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetMappingBankCompareListsuccess(res.data));
                    break;
                default:
                    dispatch(adminGetMappingBankCompareListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETMAPPINGBANKLISTCOMPARE,
                payload: err
            });
        });
};


function adminGetMappingBankCompareListsuccess(data) {
    return {
        type: ADMINGETMAPPINGBANKLISTCOMPARE_SUCCESS,
        payload: data
    };
}
function adminGetMappingBankCompareListFailed(data) {
    return {
        type: ADMINGETMAPPINGBANKLISTCOMPARE_FAILED,
        payload: data
    };
}

export { AdminGetMappingBankCompareLists, resetAdminGetMappingBankCompareList }